export default function openChest() {
	return (dispatch, getState) => {
		dispatch({
			type: 'OPEN_CHEST',
		});
	};
}


// WEBPACK FOOTER //
// ./src/actions/openChest.js